import { apiGet, apiPatch } from 'shared/services/api/resource';
import { MY_AGENDA_ITEMS } from 'modules/jogador/agenda/content';
import { AgendaItem } from 'modules/jogador/agenda/types';

export function fetchMyAgenda(): Promise<AgendaItem[]> {
  return apiGet(MY_AGENDA_ITEMS, '/me/agenda');
}

export function cancelAgendaItem(id: string) {
  return apiPatch({ id, status: 'cancelado' as const }, `/me/agenda/${id}`, { status: 'cancelado' });
}
